// extracted by mini-css-extract-plugin
export default {"card":"card_FjIC5","cover":"cover_MeYrQ","info":"info_PQQeM","title":"title_A2H34","btn":"btn_Mcgtg"};